<div class="fs-normal border-bottom border-3 border-dark-gray px-2">
	<div [class]="containerClasses">
		<ul class="nav nav-tabs nav-justified ">
			<li class="nav-item pl-1 pt-1" *ngFor="let tab of tabs">
				<span class="nav-link py-1 px-2 rounded-top-xl h-100 no-wrap" 
					[class.f-white]="tab.active" [class.dark-gray-bg]="tab.active"
					[class.font-weight-bold]="tab.active" 
					[class.white-bg]="!tab.active" [class.border]="!tab.active"
					(click)="setTab(tab.name)">{{tab.title}}</span>
			</li>
		</ul>
	</div>
</div>